// extracted by mini-css-extract-plugin
module.exports = {"profile-avatar":"EditProfilePicture_profile-avatar__1m_rV","edit-avatar":"EditProfilePicture_edit-avatar__4lLjw"};